import { render, staticRenderFns } from "./clientProfileManageCustomAttributes.vue?vue&type=template&id=539f8f0b&scoped=true"
import script from "./clientProfileManageCustomAttributes.vue?vue&type=script&lang=js"
export * from "./clientProfileManageCustomAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539f8f0b",
  null
  
)

export default component.exports